<template lang="pug">
    MatchMedia(v-slot='{ screenSM }')
        .main-layout
            left-bar
            .main-layout__center
                .main-layout__top
                    creator-search-control.main-layout__top-search(v-if='screenSM || !title')
                    .main-layout__top-back(v-else)
                        div(@click='$router.back()')
                            svg-icon(iconId='arrow-back')
                        div {{ title }}

                    slot(v-if='!screenSM' name='mobile-top-controls')
                        main-layout-top-right
                    main-layout-top-right(v-else)

                scrollable-layout.main-layout__content-scroll
                    .main-layout__content-position
                        .main-layout__content
                            slot

                .main-layout__bottom
</template>

<script>
import { MatchMedia } from 'vue-component-media-queries'

export default {
    name: 'main-layout',

    components: {
        MatchMedia,
    },

    computed: {
        title() {
            return this.$route.meta.title || ''
        },
    },
}
</script>
